import { styled } from 'styled-components';

export const Prompt = styled.div`
  margin: 0 auto 12px auto;
  max-width: 970px;
  text-align: center;
`;

export const PromptHeading = styled.h2`
  margin: 0 0 4px 0;
  color: ${(p) => p.theme.colors.oxfordBlue[100]};
  font-family: ${(p) => p.theme.fontFamily.montserrat};
  font-size: ${(p) => p.theme.fontSizes.l};
  font-weight: 600;
`;

export const PromptText = styled.p`
  margin: 0;
  color: ${(p) => p.theme.colors.oxfordBlue[80]};
  font-family: ${(p) => p.theme.fontFamily.montserrat};
  font-size: ${(p) => p.theme.fontSizes.s};
`;

export const HandBadge = styled.span`
  display: inline-block;
  margin-top: 8px;
  padding: 2px 12px;
  border-radius: 999px;
  background: ${(p) => p.theme.colors.tiffanyGreen[10]};
  color: ${(p) => p.theme.colors.tiffanyGreen[100]};
  font-family: ${(p) => p.theme.fontFamily.montserrat};
  font-size: ${(p) => p.theme.fontSizes.s};
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

export const ProcessingOverlay = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 360px;
  gap: 12px;
  color: ${(p) => p.theme.colors.oxfordBlue[80]};
  font-family: ${(p) => p.theme.fontFamily.montserrat};
`;

export const Banner = styled.div<{ $variant: 'error' | 'success' }>`
  margin: 12px auto 0 auto;
  max-width: 970px;
  padding: 12px 16px;
  border-radius: 8px;
  background: ${(p) => (p.$variant === 'error' ? p.theme.colors.alertRed[10] : p.theme.colors.emeraldGreen[10])};
  color: ${(p) => (p.$variant === 'error' ? p.theme.colors.alertRed[100] : p.theme.colors.emeraldGreen[100])};
  font-family: ${(p) => p.theme.fontFamily.montserrat};
  font-size: ${(p) => p.theme.fontSizes.s};
  text-align: center;
`;

export const AttemptCounter = styled.p`
  margin: 8px 0 0 0;
  color: ${(p) => p.theme.colors.oxfordBlue[50]};
  font-family: ${(p) => p.theme.fontFamily.montserrat};
  font-size: ${(p) => p.theme.fontSizes.xs};
  text-align: center;
`;
